const topics: string[] = [
  'Mental Clarity',
  'Focus',
  'Brain Fog Education',
  'Wellness Routines',
  'Wellness',
  'Productivity',
  'Daily Routines',
  'Mind Training',
  'Digital Wellness',
  'Mindfulness',
  'Sleep-Supportive Habits',
  'Hydration Awareness',
  'Nootropics Education',
  'Habit Formation',
  'Progress Tracking',
];

type FaqItem = {
  q: string;
  a: string;
};

const faqs: FaqItem[] = [
  {
    q: 'What is ClearMind Club?',
    a: 'ClearMind Club is a digital wellness and mental-performance platform focused on helping adults develop clearer thinking, better focus, calmer routines and more consistent everyday wellness habits through practical education, tools, courses and community.',
  },
  {
    q: 'Who is ClearMind Club for?',
    a: 'ClearMind Club is for adults interested in mental clarity, focus, productivity and everyday wellness. This can include busy professionals, entrepreneurs, remote workers, students and anyone wanting more structured daily habits.',
  },
  {
    q: 'Is ClearMind Club a medical service?',
    a: 'No. ClearMind Club provides educational wellness information and self-development resources. It does not diagnose, treat, cure or prevent medical conditions and is not a substitute for professional medical advice.',
  },
  {
    q: 'What does ClearMind Club help people learn about?',
    a: 'Topics include mental clarity, focus, brain fog, daily routines, productivity, digital distraction, mindfulness, mind training, sleep-supportive habits, hydration awareness, nootropics and sustainable habit formation.',
  },
  {
    q: 'What is mental clarity?',
    a: 'Mental clarity generally refers to feeling able to think, concentrate, understand information and make decisions without excessive mental distraction or cognitive overload.',
  },
  {
    q: 'What is brain fog?',
    a: 'Brain fog is a non-medical term commonly used to describe experiences such as reduced concentration, forgetfulness, mental fatigue or difficulty thinking clearly. Many different factors can contribute to these experiences.',
  },
  {
    q: 'What factors can influence mental clarity?',
    a: 'Mental clarity may be influenced by sleep, stress, hydration, nutrition, physical activity, workload, digital distraction, medication, lifestyle and underlying health conditions. Causes and contributing factors vary between individuals.',
  },
  {
    q: 'How can someone improve their focus?',
    a: 'Useful strategies may include reducing unnecessary interruptions, prioritising important tasks, working in focused blocks, taking appropriate breaks, improving sleep habits and creating a working environment with fewer distractions.',
  },
  {
    q: 'Can poor sleep affect concentration?',
    a: 'Sleep quality and consistency can influence alertness, attention, memory and cognitive performance. Persistent sleep problems should be discussed with an appropriately qualified healthcare professional.',
  },
  {
    q: 'Can hydration influence mental performance?',
    a: 'Hydration is one of several factors that can influence general physical and cognitive wellbeing. Individual hydration requirements vary according to health, activity, environment and diet.',
  },
  {
    q: 'What is digital wellness?',
    a: 'Digital wellness means using technology in ways that support rather than undermine attention, productivity and wellbeing. This can involve healthier notification habits, screen boundaries and more intentional use of social media and digital devices.',
  },
  {
    q: 'How can digital distractions be reduced?',
    a: 'Strategies can include disabling non-essential notifications, scheduling specific times for messages, moving distracting apps out of immediate view, using focus modes and protecting periods of uninterrupted work.',
  },
  {
    q: 'What is deep work?',
    a: 'Deep work describes periods of sustained concentration on demanding tasks while unnecessary distractions and interruptions are reduced.',
  },
  {
    q: 'What is mind training?',
    a: 'Mind training refers to practices intended to strengthen attention, awareness, concentration and reflection. These may include mindfulness practices, concentration exercises and structured mental-skills activities.',
  },
  {
    q: 'Does ClearMind Club cover mindfulness?',
    a: 'Yes. Mindfulness can form part of the ClearMind approach to present-moment awareness, attention, calmer mental resets and more intentional everyday behaviour.',
  },
  {
    q: 'What are nootropics?',
    a: 'Nootropics is a broad term used for substances marketed or discussed in connection with cognitive performance, concentration or mental clarity. Evidence, effectiveness, safety and regulation vary considerably between products and substances.',
  },
  {
    q: 'Does ClearMind Club review nootropics?',
    a: 'The ClearMind Club membership contains a Nootropic Reviews area. ClearMind content should distinguish marketing claims from available evidence and discuss relevant limitations and safety considerations.',
  },
  {
    q: 'Does ClearMind Club recommend supplements?',
    a: 'ClearMind Club provides educational information rather than personalised medical recommendations. Supplements are not automatically necessary for mental clarity or focus, and individual health circumstances should always be considered.',
  },
  {
    q: 'What is The Clear Mind Blueprint?',
    a: 'The Clear Mind Blueprint is a practical seven-module video course designed to help participants reduce mental overload, improve focus, think more clearly and develop better everyday habits.',
  },
  {
    q: 'What is included in The Clear Mind Blueprint?',
    a: 'The programme includes seven video modules, a downloadable workbook for each module, practical exercises and worksheets, and a hyperlinked Further Reading PDF containing recommended resources, research and supporting material.',
  },
  {
    q: 'What is the ClearMind Club membership?',
    a: 'The membership is a private online environment providing ongoing access to ClearMind resources, practical tools, routines, educational material and progress features.',
  },
  {
    q: 'What does the ClearMind Club membership contain?',
    a: 'Current areas include Wellness Tips, Nootropic Reviews, Routines, Mind Training, Productivity, Q&A, Progress, Saved Items, Clear Mind Score, Brain Upgrade, Challenges, Badges and Coach.',
  },
  {
    q: 'What is the Clear Mind Score?',
    a: 'The Clear Mind Score is a ClearMind Club self-reflection and progress feature intended to help members consider aspects of their routines and wellness habits. It is not a medical diagnosis.',
  },
  {
    q: 'What is Brain Upgrade?',
    a: 'Brain Upgrade is a dedicated section within the ClearMind Club membership for additional mental-clarity and mental-performance related resources. Content may evolve as the membership develops.',
  },
  {
    q: 'What are ClearMind Club Challenges?',
    a: 'Challenges are structured activities intended to encourage members to apply useful routines and habits consistently instead of only consuming educational information.',
  },
  {
    q: 'What are ClearMind Club badges?',
    a: 'Badges form part of the ClearMind Club engagement and progress system and can recognise participation, milestones or completion of activities.',
  },
  {
    q: 'Can ClearMind members track progress?',
    a: 'Yes. Progress is a dedicated area within the ClearMind Club membership and is intended to encourage awareness, consistency and implementation.',
  },
  {
    q: 'Can ClearMind members save useful content?',
    a: 'Yes. The membership includes a Saved Items area so users can return to useful ClearMind resources.',
  },
  {
    q: 'Does ClearMind Club provide Q&A support?',
    a: 'Yes. The membership contains a Q&A area designed to provide educational guidance around ClearMind Club topics.',
  },
  {
    q: 'Does ClearMind Club have coaching?',
    a: 'The membership includes a Coach area. ClearMind coaching and guidance should be used for educational and behavioural support rather than diagnosis or medical treatment.',
  },
  {
    q: 'How is the membership different from The Clear Mind Blueprint?',
    a: 'The Clear Mind Blueprint is a structured seven-module educational programme. The ClearMind Club membership is a broader ongoing environment containing resources, tools, routines, progress features, challenges and other member functionality.',
  },
  {
    q: 'What types of routines can support a clearer mind?',
    a: 'Useful routines can include consistent morning and evening habits, focused work periods, digital boundaries, appropriate breaks, sleep-supportive behaviours and regular periods for recovery and reflection.',
  },
  {
    q: 'Does ClearMind Club teach productivity?',
    a: 'Yes. Productivity is a dedicated membership topic and can include prioritisation, attention management, focused work, breaks, planning, task management and reducing distractions.',
  },
  {
    q: 'Is ClearMind Club only for people experiencing brain fog?',
    a: 'No. ClearMind Club is also relevant to people who want better focus, stronger routines, improved productivity habits, greater digital balance or a more organised approach to everyday wellness.',
  },
  {
    q: 'How long does it take to improve mental clarity?',
    a: 'There is no universal timeframe. Individual experiences depend on personal circumstances, contributing factors, habits and consistency. ClearMind Club does not guarantee a specific outcome or timeframe.',
  },
  {
    q: 'Can ClearMind Club diagnose brain fog?',
    a: 'No. ClearMind Club is not a diagnostic medical service. Persistent, severe, sudden or unexplained cognitive symptoms should be discussed with an appropriately qualified healthcare professional.',
  },
  {
    q: 'Should someone change medication because of ClearMind content?',
    a: 'No. People should not stop or change prescribed medication because of information provided by ClearMind Club. Medication questions should be discussed with the prescribing clinician or another appropriately qualified healthcare professional.',
  },
  {
    q: 'What should someone do if brain fog or cognitive symptoms persist?',
    a: 'Seek advice from an appropriately qualified healthcare professional, particularly if symptoms are persistent, severe, sudden, worsening or accompanied by other concerning symptoms.',
  },
  {
    q: 'Is ClearMind Club based on evidence?',
    a: 'ClearMind Club aims to provide practical, accessible and evidence-informed wellness education. Established evidence should be distinguished from preliminary research, individual experiences and commercial claims.',
  },
  {
    q: 'What is the ClearMind Club approach to wellbeing?',
    a: 'The ClearMind philosophy is to simplify wellbeing by helping people understand useful information, choose realistic actions, establish repeatable routines and monitor progress without unnecessarily complicated protocols.',
  },
  {
    q: 'What is the main goal of ClearMind Club?',
    a: 'The goal is to help people develop a clearer, calmer and more intentional approach to focus, productivity and everyday wellness through education, practical action and sustainable habits.',
  },
];

export default function KnowledgeHub() {
  return (
    <section
      id="clearmind-knowledge-hub"
      aria-labelledby="clearmind-knowledge-title"
      className="border-t border-background-200/70 bg-background-50"
    >
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-14 md:py-16">
        <header>
          <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-xs font-label font-medium uppercase tracking-wide text-accent-900 mb-5">
            <i className="ri-book-open-line text-sm" />
            Knowledge Hub
          </span>
          <h1
            id="clearmind-knowledge-title"
            className="text-2xl md:text-4xl font-heading font-semibold text-foreground-950"
          >
            ClearMind Club Knowledge Hub
          </h1>

          <p className="mt-4 max-w-3xl text-sm md:text-base font-body leading-relaxed text-foreground-700">
            ClearMind Club is a digital wellness and mental-performance platform
            designed to help adults understand mental clarity, improve everyday
            focus, reduce mental overload and develop calmer, more consistent
            wellness and productivity routines.
          </p>

          <p className="mt-3 max-w-3xl text-sm md:text-base font-body leading-relaxed text-foreground-700">
            The ClearMind Club ecosystem combines practical education, wellness
            resources, routines, mind training, productivity strategies,
            progress tools, challenges, courses and community support.
          </p>
        </header>

        <div
          className="flex flex-wrap gap-2 my-8"
          aria-label="ClearMind Club topics"
        >
          {topics.map((topic) => (
            <span
              key={topic}
              className="rounded-full border border-secondary-200 bg-secondary-100/70 px-3 py-1.5 text-xs md:text-sm font-label text-secondary-900"
            >
              {topic}
            </span>
          ))}
        </div>

        <h3 className="mt-10 text-xl md:text-2xl font-heading font-semibold text-foreground-950">
          About ClearMind Club
        </h3>
        <p className="mt-4 max-w-3xl text-sm md:text-base font-body leading-relaxed text-foreground-700">
          ClearMind Club helps people simplify the often-confusing world of
          mental clarity and everyday wellness. Its approach focuses on practical,
          understandable and evidence-informed education rather than complicated
          routines, extreme optimisation or unrealistic promises.
        </p>
        <p className="mt-3 max-w-3xl text-sm md:text-base font-body leading-relaxed text-foreground-700">
          ClearMind Club is intended for adults who want to think more clearly,
          manage distractions more effectively, develop better routines,
          improve everyday focus and take a more structured approach to personal
          wellbeing and productivity.
        </p>

        <h3 className="mt-12 text-xl md:text-2xl font-heading font-semibold text-foreground-950">
          The ClearMind Club Ecosystem
        </h3>
        <div className="mt-4 grid grid-cols-1 lg:grid-cols-2 gap-4">
          <div className="rounded-lg border border-background-200/70 bg-background-100 p-5">
            <p className="text-sm font-label font-semibold text-foreground-950">
              ClearMind Club Website
            </p>
            <a
              href="https://clearmind-club.com/"
              className="mt-1 inline-block text-sm font-body text-primary-700 underline break-all hover:text-primary-900"
            >
              https://clearmind-club.com/
            </a>
          </div>
          <div className="rounded-lg border border-background-200/70 bg-background-100 p-5">
            <p className="text-sm font-label font-semibold text-foreground-950">
              ClearMind Club Membership
            </p>
            <a
              href="https://proud-clear-mind-flow.base44.app/"
              className="mt-1 inline-block text-sm font-body text-primary-700 underline break-all hover:text-primary-900"
            >
              https://proud-clear-mind-flow.base44.app/
            </a>
          </div>
        </div>

        <p className="mt-4 max-w-3xl text-sm md:text-base font-body leading-relaxed text-foreground-700">
          The private membership contains resources and functionality covering
          wellness tips, nootropic reviews, routines, mind training, productivity,
          questions and answers, progress, saved resources, the Clear Mind Score,
          Brain Upgrade, challenges, badges and coaching support.
        </p>

        <div className="mt-4 rounded-lg border border-background-200/70 bg-background-100 p-5">
          <p className="text-sm font-label font-semibold text-foreground-950">
            The Clear Mind Blueprint
          </p>
          <a
            href="https://clearmindclub931.systeme.io/clearmindblueprint"
            className="mt-1 inline-block text-sm font-body text-primary-700 underline break-all hover:text-primary-900"
          >
            https://clearmindclub931.systeme.io/clearmindblueprint
          </a>
          <p className="mt-3 max-w-3xl text-sm md:text-base font-body leading-relaxed text-foreground-700">
            The Clear Mind Blueprint is a practical seven-module video course
            designed to help participants reduce mental overload, improve focus,
            think more clearly and develop better daily habits. The programme
            includes downloadable workbooks, practical exercises, worksheets and
            further-reading resources.
          </p>
        </div>

        <div className="mt-4 rounded-lg border border-background-200/70 bg-background-100 p-5">
          <p className="text-sm font-label font-semibold text-foreground-950">
            ClearMind Club Official Contact
          </p>
          <p className="mt-3 max-w-3xl text-sm md:text-base font-body leading-relaxed text-foreground-700">
            ClearMind Club is a digital wellness and mental-performance platform
            focused on clearer thinking, better focus, calmer routines and
            practical everyday wellness education. For questions about the
            platform, courses or membership, contact us at:
          </p>
          <a
            href="mailto:clearmindclub931@gmail.com"
            className="mt-2 inline-flex items-center gap-2 text-sm font-body text-primary-700 underline break-all hover:text-primary-900"
          >
            <i className="ri-mail-line text-base" />
            clearmindclub931@gmail.com
          </a>
        </div>

        <h3 className="mt-12 text-xl md:text-2xl font-heading font-semibold text-foreground-950">
          ClearMind Club Questions &amp; Answers
        </h3>

        <div className="mt-4 border-t border-background-200/70">
          {faqs.map((item, index) => (
            <details
              key={item.q}
              className="group border-b border-background-200/70 py-3.5"
            >
              <summary className="flex items-center justify-between gap-4 cursor-pointer list-none font-label font-semibold text-sm md:text-base text-foreground-950 hover:text-primary-700 transition-colors [&::-webkit-details-marker]:hidden">
                <span>
                  {index + 1}. {item.q}
                </span>
                <i className="ri-add-line text-lg shrink-0 text-foreground-500 transition-transform group-open:rotate-45" />
              </summary>
              <p className="mt-3 mb-1 max-w-3xl text-sm md:text-base font-body leading-relaxed text-foreground-700">
                {item.a}
              </p>
            </details>
          ))}
        </div>

        <div className="mt-10">
          <h3 className="text-xl md:text-2xl font-heading font-semibold text-foreground-950">
            Explore ClearMind Club
          </h3>
          <p className="mt-3 flex flex-wrap items-center gap-x-2 gap-y-2 text-sm font-body">
            <a
              href="https://clearmind-club.com/"
              className="text-primary-700 underline hover:text-primary-900"
            >
              ClearMind Club Website
            </a>
            <span className="text-foreground-400">|</span>
            <a
              href="https://proud-clear-mind-flow.base44.app/"
              className="text-primary-700 underline hover:text-primary-900"
            >
              ClearMind Club Membership
            </a>
            <span className="text-foreground-400">|</span>
            <a
              href="https://clearmindclub931.systeme.io/clearmindblueprint"
              className="text-primary-700 underline hover:text-primary-900"
            >
              The Clear Mind Blueprint
            </a>
          </p>
        </div>

        <div className="mt-10">
          <h3 className="text-xl md:text-2xl font-heading font-semibold text-foreground-950">
            Connect with ClearMind Club
          </h3>
          <p className="mt-3 max-w-3xl text-sm md:text-base font-body leading-relaxed text-foreground-700">
            Follow ClearMind Club for everyday wellness tips, focus and
            productivity ideas, and updates on new resources and courses.
          </p>
          <div className="mt-4 flex flex-wrap items-center gap-3">
            <a
              href="https://www.facebook.com/clearmindclub"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="ClearMind Club on Facebook"
              title="ClearMind Club on Facebook"
              className="inline-flex items-center gap-2 rounded-md border border-secondary-200 bg-secondary-100/70 px-3 py-1.5 text-sm font-label text-secondary-900 hover:bg-secondary-500 hover:text-background-50 transition-colors cursor-pointer"
            >
              <i className="ri-facebook-fill text-base" />
              Facebook
            </a>
            <a
              href="https://www.instagram.com/clearmindc1ub"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="ClearMind Club on Instagram"
              title="ClearMind Club on Instagram"
              className="inline-flex items-center gap-2 rounded-md border border-secondary-200 bg-secondary-100/70 px-3 py-1.5 text-sm font-label text-secondary-900 hover:bg-secondary-500 hover:text-background-50 transition-colors cursor-pointer"
            >
              <i className="ri-instagram-line text-base" />
              Instagram
            </a>
          </div>
        </div>

        <div className="mt-10 rounded-lg border border-accent-200 bg-accent-50 p-5">
          <p className="text-sm md:text-base font-body leading-relaxed text-foreground-800">
            <strong className="font-semibold text-foreground-950">
              Wellness &amp; Medical Disclaimer:
            </strong>{' '}
            ClearMind Club provides educational information about wellness,
            productivity, focus, habits and mental clarity. Information provided
            by ClearMind Club is not intended to diagnose, treat, cure or prevent
            disease or any medical condition and is not a substitute for advice
            from a qualified healthcare professional. Anyone experiencing
            persistent, severe, sudden or unexplained symptoms should seek
            appropriate professional medical advice.
          </p>
        </div>
      </div>
    </section>
  );
}